import React from "react";

/**
 * Modal component for adding/changing species audio files
 * 
 * @param {boolean} isOpen - Controls modal visibility
 * @param {Function} onClose - Callback to close the modal
 * @param {Object} specieSound - Existing sound data {id, file_path, specie_id}
 * @param {File} audioFile - Currently selected audio file
 * @param {Function} handleAudioFileChange - Handler for audio file input change
 * @param {Function} handleAddSpecieSound - Handler to upload audio file
 */
export default function AddAudioModal({
    isOpen,
    onClose,
    specieSound,
    audioFile,
    handleAudioFileChange,
    handleAddSpecieSound
}) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
                <div className="p-6 border-b border-gray-200">
                    <h3 className="font-heading text-2xl font-bold text-charcoal">
                        {specieSound ? "Ändra ljudspår" : "Lägg till ljudspår"}
                    </h3>
                </div>
                
                <div className="p-6">
                    <div className="space-y-4">
                        <div>
                            <label className="block text-sm font-semibold text-charcoal mb-2">
                                Välj ljudfil (MP3, WAV, OGG)
                            </label>
                            <input
                                type="file"
                                accept="audio/*"
                                onChange={handleAudioFileChange}
                                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                            />
                        </div>
                        
                        {/* Preview selected audio */}
                        {audioFile && (
                            <div className="bg-purple-50 rounded-lg p-4">
                                <p className="text-sm text-purple-800 font-medium mb-2">Förhandsvisning:</p>
                                <audio 
                                    controls 
                                    className="w-full"
                                    src={URL.createObjectURL(audioFile)}
                                >
                                    Din webbläsare stödjer inte ljuduppspelning.
                                </audio>
                            </div>
                        )}
                    </div>
                </div>
                
                <div className="p-6 border-t border-gray-200 flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 bg-gray-200 hover:bg-gray-300 text-charcoal font-semibold py-3 px-4 rounded-lg transition-colors duration-200"
                    >
                        Avbryt
                    </button>
                    <button
                        onClick={handleAddSpecieSound}
                        disabled={!audioFile}
                        className={`flex-1 font-semibold py-3 px-4 rounded-lg transition-colors duration-300 ${
                            audioFile 
                                ? 'bg-purple-600 hover:bg-purple-700 text-white' 
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        Spara ljudspår
                    </button>
                </div>
            </div>
        </div>
    );
}
